module.exports = __webpack_public_path__ + "img/logo-instagram.b3a462d9.svg";